export enum CompanyProfileStepsTooltipContentBlock {
  Root = 'CompanyProfileStepsTooltipContent',
}

export enum CompanyProfileStepsTooltipContentElement {
  title = 'title',
  content = 'content',
}
